module.exports = __webpack_public_path__ + "assets/idin.441351cb.svg";